<div
  class="not-found d-block d-xl-flex flex-row justify-content-center align-items-center">
  <div class="text-block">
    <h1 class="mb-6">Error</h1>
    <h4 class="mt-4">There's no where to go from here.</h4>
    <p>
      <span *ngIf="canUserAccessNewQuote || canUserAccessBilling"
        >Please go back or contact us for help at
      </span>
      <span *ngIf="!canUserAccessNewQuote && !canUserAccessBilling"
        >Contact us for help at
      </span>
      <a (click)="contactSWBC()">{{ helpEmail }}</a
      >.
    </p>
    <div class="error-stack" *ngIf="isShowErrorPanel && error">
      <div class="error-row-items">
        <span>App Meta: </span>
        <span class="error-chip">Env: {{ error.environment | uppercase }}</span>
        <span class="error-chip">App: {{ error.app | uppercase }}</span>
        <span class="error-chip" *ngIf="error.route"
          >Route: {{ error.route }}</span
        >
      </div>
      <div class="error-row-items">
        <span *ngIf="error.source">Source: {{ error.source | uppercase }}</span>
        <span *ngIf="error.method">Method: {{ error.method }}</span>
        <span *ngIf="error.status">Status: {{ error.status }}</span>
        <span *ngIf="error.statusText"
          >Status Text: {{ error.statusText }}</span
        >
      </div>
      <div class="error-row-items" *ngIf="error.url">
        <span>Endpoint: {{ error.url }}</span>
      </div>
      <div class="error-row-items" *ngIf="error.message">
        <span>Error Message: {{ error.message }}</span>
      </div>
      <div class="error-row-items" *ngIf="error.stack">
        <span>Error Stack: {{ error.stack }}</span>
      </div>
      <button
        mat-mini-fab
        class="copy-clipboard"
        color="primary"
        matTooltip="Copy error"
        matTooltipPosition="above"
        (click)="copyErrorToClipboard()">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
    <a
      mat-flat-button
      color="primary"
      class="min-295 px-1 mt-3 text-white"
      (click)="redirect()"
      *ngIf="canUserAccessBilling || canUserAccessNewQuote">
      Go back to {{ buttonText }} Page
    </a>
  </div>

  <div>
    <img src="../../../../assets/svg/404.svg" alt="404 error" />
  </div>
</div>
